import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";

export const SignaturePad = forwardRef(({ onInk }, ref) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const last = useRef(null);
  const inked = useRef(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = c.getBoundingClientRect();
    c.width = rect.width * ratio;
    c.height = rect.height * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    Object.assign(ctx, { lineWidth: 2.6, lineCap: "round", lineJoin: "round", strokeStyle: "#0B0F19" });
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const down = (e) => {
    e.preventDefault();
    canvasRef.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    last.current = pos(e);
  };
  const move = (e) => {
    if (!drawing.current) return;
    const p = pos(e);
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(last.current.x, last.current.y);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    last.current = p;
    if (!inked.current) {
      inked.current = true;
      onInk?.(true);
    }
  };
  const up = () => (drawing.current = false);

  useImperativeHandle(ref, () => ({
    clear() {
      const c = canvasRef.current;
      c.getContext("2d").clearRect(0, 0, c.width, c.height);
      inked.current = false;
      onInk?.(false);
    },
    toDataURL: () => canvasRef.current.toDataURL("image/png"),
    isEmpty: () => !inked.current,
  }));

  return (
    <canvas
      ref={canvasRef}
      data-testid="signature-canvas"
      className="h-56 w-full touch-none rounded-lg bg-white"
      style={{ touchAction: "none" }}
      onPointerDown={down}
      onPointerMove={move}
      onPointerUp={up}
      onPointerCancel={up}
    />
  );
});
SignaturePad.displayName = "SignaturePad";
